var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_sidebar"},[_c('ul',{staticClass:"_sidebar_ul"},_vm._l((_vm.menu),function(item,index){return _c('li',{key:index,class:_vm.activeIndex==index?'router-link-active':'',on:{"click":function($event){return _vm.changeActive(index)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }